// ** Icons Import
import { Home, Circle } from 'react-feather'

export default [
  {
    id: 'home',
    title: 'Home',
    // icon: <Home size={20} />,
    badge: 'light-warning',
    navLink: '/home',
  },
  // {
  //   id: 'myTricks',
  //   title: 'My Tricks',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/my-tricks'
  // },
  // {
  //   id: 'myTrickProfit',
  //   title: 'My Trick Profit',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/my-trick-profit',
  // },
  // {
  //   id: 'TradeHistory',
  //   title: 'Trade History',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/trade-history',
  // },
  // {
  //   id: 'OrderHistOry',
  //   title: 'Order History',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/order-history',
  // },
  {
    id: 'ReferAndEarn',
    title: 'Refer & Earn',
    // icon: <Circle size={20} />,
    badge: 'light-warning',
    navLink: '/refer-and-earn',
  },
  {
    id: 'rewardHistory',
    title: 'Reward History',
    // icon: <Circle size={20} />,
    badge: 'light-warning',
    navLink: '/reward-history',
  },
  // {
  //   id: 'myTeam',
  //   title: 'My Team',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/my-team',
  // },
  {
    id: 'myWallet',
    title: 'My Wallet',
    // icon: <Circle size={20} />,
    badge: 'light-warning',
    navLink: '/my-wallet',
  },
  {
    id: 'WalletHistory',
    title: 'Wallet History',
    // icon: <Circle size={20} />,
    badge: 'light-warning',
    navLink: '/wallet-history',
  },
  // {
  //   id: 'MySubscription',
  //   title: 'My Subscription',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/my-subscription',
  // },
  // {
  //   id: 'MyTrnsaction',
  //   title: 'My Transactions',
  //   // icon: <Circle size={20} />,
  //   badge: 'light-warning',
  //   navLink: '/my-transactions',
  // },
 
  // {
  //   id: 'InfoVideos',
  //   title: 'Info Videos',
  //   // icon: <Circle size={20}
  //   navLink: '/info-videos',
  // },
  // {
  //   id: 'joinWebiner',
  //   title: 'Webinar',
  //   // icon: <Circle size={20}
  //   navLink: '/join-webiner',
  // },
  // {
  //   id: 'faq',
  //   title: 'FAQs',
  //   // icon: <Circle size={20}
  //   navLink: '/faq',
  // },
  // {
  //   id: 'RaiseTicket',
  //   title: 'Raise Ticket',
  //   // icon: <Circle size={20}
  //   navLink: '/raise-ticket',
  // },
  // {
  //   id: 'Logs',
  //   title: 'Logs',
  //   // icon: <Circle size={20}
  //   navLink: '/logs',
  // }
]
